// extracted by css-extract-rspack-plugin
export default {"stepper":"stepper-lbxgzA","step":"step-QoiTdQ","active":"active-es59cv"};